import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AuthContext from "../../auth/context";
import { useHistory } from "react-router-dom";
import serverHost from "../../services/serverHost";

import {
  AppBar,
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  styled,
  Toolbar,
} from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import FolderIcon from "@mui/icons-material/Folder";
import CustomizedSnackbars from "../../components/alert/Alert";

let cicloAnterior = 0;
let text = "";
let tipo = "";

export default function Unidades({ props }) {
  const [alerta, setAlerta] = useState(false);
  const [listaUnidades, setListaUnidades] = useState([]);
  const [acesso, setAcesso] = useState(0);
  const usuario = useContext(AuthContext);
  const history = useHistory();

  useEffect(() => {
    listarUnidades();
  }, []);

  const listarUnidades = () => {
    api
      .get("agenda/profissional", { usuarioId: usuario.usuario.usuarioId })
      .then((res) => {
        const unidades = [];
        console.log("res", res);

        res.ciclos.forEach((unidade) => {
          if (cicloAnterior !== unidade.id) {
            cicloAnterior = unidade.id;

            unidades.push({ nomeCiclo: unidade.nome });
          }
          unidade.unidades.forEach((item, index) => {
            unidades.push({
              acessoCoordenacao: item.acessoCoordenacao,
              acompanhamentoAberto: item.acompanhamentoAberto,
              disponivelAte: item.disponivelAte,
              cicloNome: item.cicloNome,
              unidadeId: item.unidadeId,
              situacao: item.situacao,
              unidadeNumero: item.unidadeNumero,
              unidadeTitulo: item.unidadeTitulo,
            });
          });
        });
        setAcesso(unidades[1].acessoCoordenacao);
        setListaUnidades(unidades);
      })
      .catch((e) => {
        console.log(e);

        const status = e.status;

        if (status === 400) {
          text =
            "Não foi possível obter as unidades. Verifique sua conexão e tente novamente.";
          tipo = "error";
          alertMsg();
        }
      });
  };

  const abrirCoordenacao = (dadosUnidade) => {
    history.push({
      pathname: "coordenacao",
      state: { dadosUnidade: dadosUnidade },
    });
  };
  const abrirUnidade = (dadosUnidade) => {
    history.push({
      pathname: "unidade",
      state: { dadosUnidade: dadosUnidade },
    });
  };

  const abrirAcompanhamento = (unidade) => {
    let dadosUnidade = unidade;

    history.push({
      pathname: "acompanhamento",
      state: { dadosUnidade: dadosUnidade },
    });
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <div>
      <AppBar position="fixed">
        <Toolbar style={{ background: "#3d79bd" }}>
          <h2
            style={{
              fontWeight: "bolder",
              color: "white",
              fontFamily: "Gilroy-ExtraBold",
            }}
          >
            Unidades
          </h2>
        </Toolbar>
      </AppBar>

      <Main
        style={{
          background: "white",
          fontFamily: "Gilroy-ExtraBold",
        }}
      >
        <Toolbar />

        {listaUnidades.map((unidade, index) => (
          <>
            <br />
            <div style={{ background: "#a3a3a3" }}>
              <h3
                style={{ fontWeight: "bold", color: "white", marginLeft: 10 }}
              >
                {unidade.nomeCiclo}
              </h3>
            </div>

            <div style={{ padding: "0px 10px 0 10px" }}>
              {unidade.unidadeId && (
                <ListItem
                  sx={{
                    width: "100%",
                    bgcolor: "#e8e8e8",
                    borderRadius: "20px",
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      sx={{ width: 40, height: 40 }}
                      src={`${serverHost()}/storage/unidades/capas/352.png`}
                    ></Avatar>
                  </ListItemAvatar>

                  <ListItemText
                    primary={
                      <h3 style={{ fontFamily: "Gilroy-ExtraBold" }}>
                        {unidade.unidadeNumero + " - " + unidade.unidadeTitulo}
                      </h3>
                    }
                    secondary={
                      <p style={{ fontFamily: "Gilroy-ExtraBold" }}>
                        {unidade.situacao}
                      </p>
                    }
                  />
                  {acesso === 1 && (
                    <IconButton
                      sx={{
                        background: "#EC691A",
                        color: "#FFFF",
                        marginRight: 2,
                      }}
                      onClick={() => abrirCoordenacao(unidade)}
                    >
                      <ContentPasteIcon />
                    </IconButton>
                  )}
                  <IconButton
                    sx={{
                      background: "#E51D3D",
                      color: "#FFFF",
                      marginRight: 2,
                    }}
                    onClick={() => abrirUnidade(unidade)}
                  >
                    <FolderIcon />
                  </IconButton>
                  <IconButton
                    sx={{ background: "#0EA366", color: "#FFFF" }}
                    variant="contained"
                    onClick={() => abrirAcompanhamento(unidade)}
                  >
                    <ChatIcon />
                  </IconButton>
                </ListItem>
              )}
            </div>
          </>
        ))}
        <br />
        <Toolbar />
      </Main>
      {alerta && (
        <CustomizedSnackbars texto={text} tipo={tipo}></CustomizedSnackbars>
      )}
    </div>
  );
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 250,
    }),
  })
);
